import React from "react"

import Slider from "react-slick"
import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore"

import Button from "../Button/Button"

const TrainingCarousel = (props) => {
  const [content, setContent] = React.useState("")
  const [contentName, setContentName] = React.useState("")

  const { carousel } = props

  const NextArrow = ({ currentSlide, slideCount, ...props }) => (
    <div className="next-arrow">
      <NavigateNextIcon {...props} />
    </div>
  )
  const PrevArrow = ({ currentSlide, slideCount, ...props }) => (
    <div className="prev-arrow">
      <NavigateBeforeIcon {...props} />
    </div>
  )

  const settings = {
    dots: false,
    arrows: true,
    lazyload: true,
    infinite: true,
    autoplay: false,
    draggable: false,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          draggable: true,
          arrows: true,
          infinite: true,
          autoplay: false
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
          slidesToScroll: 1,
          draggable: true,
          arrows: true,
          infinite: true,
        },
      },
    ],
  }

  return (
    <div className="training-carousel-content">
      <Slider {...settings} className="training-carousel">
        {carousel.map((card, index) => {
          return (
            <div className="training-carousel-item-wrapper" key={index}>
              <div
                className="training-carousel-item"
                style={{
                  background: `url(${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${card.value.asset_training_picture.path})`,
                }}
              >
                <h3>{card.value.text_training_name}</h3>
                <div
                  className="short_description"
                  dangerouslySetInnerHTML={{
                    __html: card.value.wysiwyg_training_short_description,
                  }}
                ></div>
                <div className="button-wrapper">
                  <Button
                    type="primary"
                    model="2"
                    text={card.value.text_button_text}
                    onClick={() => {
                      setContent(card.value.wysiwyg_training_description)
                      setContentName(card.value.text_training_name)
                    }}
                  />
                </div>
              </div>
            </div>
          )
        })}
      </Slider>
      <div className="content">
        <h1>{contentName}</h1>
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
      </div>
    </div>
  )
}

export default TrainingCarousel
